import { Substitutes } from '@mews-framework/localization';

export enum CustomErrorType {
    TimeString = 'TimeString',
    DateString = 'DateString',
    DateRange = 'DateRange',
    BirthDateString = 'BirthDateString',
    FormattedNumber = 'FormattedNumber',
    FileSize = 'FileSize',
    Other = 'Other',
}

export type CustomErrorParams =
    | { errorType: CustomErrorType.TimeString }
    | { errorType: CustomErrorType.DateString }
    | { errorType: CustomErrorType.DateRange }
    | { errorType: CustomErrorType.BirthDateString; minBirthDate: string }
    | { errorType: CustomErrorType.FormattedNumber }
    | { errorType: CustomErrorType.FileSize; maxSize: string }
    | { errorType: CustomErrorType.Other; textKey?: Mews.TextKey; substitutes?: Substitutes };
